import {filter, includes, toLower, trim} from 'ramda';
import {isNotNilOrEmpty} from 'ramda-adjunct';

import {RelativeFilterResponseBody} from '../../../../../types/api/api';

export function filterPresetsBySearch(
  presets: RelativeFilterResponseBody[],
  searchQuery: string | null
): RelativeFilterResponseBody[] {
  if (!isNotNilOrEmpty(trim(searchQuery ?? ''))) {
    return presets;
  }

  const query = toLower(trim(searchQuery ?? ''));

  return filter((preset) => includes(query, toLower(preset.name)), presets);
}
